import { useEffect, useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { useTranslation } from "react-i18next";

const BrandCarousel = () => {
  const { t } = useTranslation();
  // Hotel brand logos - these are placeholder names that will be styled as text
  // In production, these would be replaced with actual logo images
  const brands = [
    { name: "Kempinski", subtitle: "HOTELS & RESORTS" },
    { name: "Villa Giardino", subtitle: "L'hotel con un po' di già" },
    { name: "Villa Contessa", subtitle: "Deutschlands schönste Vier Class Hotel" },
    { name: "Hotel Excelsior", subtitle: "Dubrovnik" },
    { name: "Swiss Majestic", subtitle: "GRAND HOTEL" },
    { name: "Geisel", subtitle: "PRIVATHOTELS" },
    { name: "Ruby", subtitle: "HOTELS" },
    { name: "Renaissance", subtitle: "HOTELS & RESORTS" },
    { name: "Palais Coburg", subtitle: "★★★★★" },
  ];

  const [emblaRef, emblaApi] = useEmblaCarousel(
    { 
      loop: true,
      align: "start",
      slidesToScroll: 1,
      skipSnaps: false,
      containScroll: "trimSnaps",
    },
    [Autoplay({ delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true })]
  );
  
  useEffect(() => {
    if (emblaApi) {
      emblaApi.on('settle', () => {
        // Ensure carousel stays in bounds
        if (!emblaApi.canScrollNext() && !emblaApi.canScrollPrev()) {
          emblaApi.reInit();
        }
      });
    }
  }, [emblaApi]);

  return (
    <section className="pt-24 pb-16 bg-background overflow-hidden">
      <div className="container-page max-w-4xl">
        <div className="measure-wide mx-auto stack-lg typo mb-20">
          <h2 className="h1 text-center mb-4">
            {t("brands.title")}
          </h2>
          <p className="subline-gold">
            {t("brands.subtitle")}
          </p>
          <p className="body text-center">
            {t("brands.description1")}
          </p>
          <p className="body text-center">
            {t("brands.description2")}
          </p>
          <p className="body text-center">
            {t("brands.description3")}
          </p>
        </div>
      </div>
      
      <div className="overflow-hidden" ref={emblaRef}>
        <div className="flex gap-12 md:gap-16">
          {brands.map((brand, index) => (
            <div
              key={index}
              className="flex-[0_0_200px] md:flex-[0_0_250px] flex items-center justify-center"
            >
              <div className="text-center opacity-80 hover:opacity-100 transition-opacity duration-300">
                <div className="font-heading text-xl md:text-2xl font-light tracking-wider mb-1">
                  {brand.name}
                </div>
                <div className="font-body text-xs text-foreground/70 tracking-widest">
                  {brand.subtitle}
                </div>
              </div>
            </div>
          ))}
          {/* Duplicate for seamless loop */}
          {brands.map((brand, index) => (
            <div
              key={`duplicate-${index}`}
              className="flex-[0_0_200px] md:flex-[0_0_250px] flex items-center justify-center"
            >
              <div className="text-center opacity-80 hover:opacity-100 transition-opacity duration-300">
                <div className="font-heading text-xl md:text-2xl font-light tracking-wider mb-1">
                  {brand.name}
                </div>
                <div className="font-body text-xs text-foreground/70 tracking-widest">
                  {brand.subtitle}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandCarousel;
